import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://api.pansurvey.org',
    retry: false,  // Disable retry (if retrying is causing issues)
    headers: {
        'Content-Type': 'application/json',
    },
});

export default axiosInstance;
